import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useMemo } from "react";
import { connect } from "react-redux";
import actions from "../store/actions/user/actions";
import * as asyncActions from "../store/actions/user/asyncActions";
import bindActionCreators from "@magento/peregrine/lib/util/bindActionCreators";
var UserContext = createContext();
var UserContextProvider = props => {
  var {
    actions,
    asyncActions,
    children,
    userState
  } = props;
  var userApi = useMemo(() => _objectSpread({
    actions
  }, asyncActions), [actions, asyncActions]);
  var contextValue = useMemo(() => [userState, userApi], [userApi, userState]);
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: contextValue
  }, children);
};
var mapStateToProps = _ref => {
  var {
    user
  } = _ref;
  return {
    userState: user
  };
};
var mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  asyncActions: bindActionCreators(asyncActions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(UserContextProvider);

/**
 * @typedef {Object} UserState
 *
 * @property {CurrentUser} currentUser Current user details
 * @property {Error} getDetailsError Get Details call related error
 * @property {Boolean} isGettingDetails Boolean if true indicates that user details are being fetched. False otherwise.
 * @property {Boolean} isResettingPassword Deprecated
 * @property {Boolean} isSignedIn Boolean if true indicates that the user is signed in. False otherwise.
 * @property {Error} resetPasswordError Deprecated
 *
 */

/**
 * @typedef {Object} CurrentUser
 *
 * @property {String} email Current user's email
 * @property {String} firstname Current user's first name
 * @property {String} lastname Current user's last name
 */

/**
 * @typedef {Object} UserActions
 *
 * @property {Function} clearToken Callback to clear user token in browser persistence storage
 * @property {Function} getUserDetails Callback to get user details
 * @property {Function} resetPassword Deprecated
 * @property {Function} setToken Callback to set user token in browser persistence storage
 * @property {Function} signOut Callback to sign the user out
 */

/**
 * @returns {[UserState, UserActions]}
 */
export var useUserContext = () => useContext(UserContext);